import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout';
import OrderCard from '../../components/orderCard';
import { withRouter } from 'react-router-dom';
import { withAlert } from 'react-alert';
import { ENUM_LAYOUT_STATE } from '../../helpers/enums';
import { OrderService } from '../../services/order.service';
import { STORAGE_KEYS } from '../../helpers/constants';
import useLayoutContext from '../../contexts/layout.context';
import { searchOrders } from '../../helpers/functions';

const Preorder = () => {
  const { testMode } = useLayoutContext();
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);

  const loadOrders = async () => {
    const res = await OrderService.getPreorderedOrders({
      cokitchen_id: cokitchenId,
      test: testMode,
      company: false
    });
    const scheduled = res?.data ?? [];
    setOrders(
      scheduled
        .filter((o) => o.paid)
        ?.map((o) => ({
          ...o,
          preorder: true
        }))
        .sort(
          (a, b) =>
            new Date(a.kitchen_delivery_datetime).getTime() -
            new Date(b.kitchen_delivery_datetime).getTime()
        )
    );
    setLoading(false);
  };

  useEffect(async () => {
    setLoading(true);
    loadOrders();
  }, [testMode]);

  useEffect(() => {
    const filtered = searchOrders({ searchValue, orders });
    setFilteredOrders(filtered);
  }, [orders, searchValue]);

  const getLayoutState = () => {
    if (filteredOrders.length === 0 && searchValue) return ENUM_LAYOUT_STATE.EMPTY_SEARCH;
    if (loading) return ENUM_LAYOUT_STATE.LOADING;
    return ENUM_LAYOUT_STATE.PAGE;
  };
  return (
    <Layout
      pendingOrders={0}
      trackingOrders={orders.length}
      searchValue={searchValue}
      searchChange={(e) => setSearchValue(e.target.value?.toUpperCase())}
      layoutState={getLayoutState()}>
      {filteredOrders.map((item, i) => (
        <OrderCard
          key={item.id + item.updated_at}
          order={item}
          onActionClick={loadOrders}
          hideCardButton
          isPreOrderPage
        />
      ))}
      {orders.length === 0 && (
        <div className='text-[3rem] text-white text-center flex grow items-center justify-center'>
          There are no Pre ordered orders
        </div>
      )}
    </Layout>
  );
};
export default withRouter(withAlert()(Preorder));
